import React, { memo } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import { DROP_TYPE_OPTIONS } from 'apps/rms/constants/shipperRates'
import { IShipperRate } from 'apps/rms/types/shipperRates'

interface IDropTypeProps {
  value: RecursivePartial<IShipperRate>
  onChange(change: RecursivePartial<IShipperRate>): void
  type: 'pickup' | 'delivery'
}

export const DropType = memo<IDropTypeProps>(({ onChange, type, value }) => {
  const dropType = type === 'pickup' ? 'isPickupDropTrailer' : 'isDeliveryDropTrailer'
  const dropTypeHandler = (e: ISelectOption<string>) => {
    onChange({ [dropType]: e.value === 'true' })
  }

  return (
    <div className='col-md-4 col-xs-4'>
      <Select
        label='Drop Type'
        options={DROP_TYPE_OPTIONS}
        value={value[dropType]?.toString()}
        onChange={dropTypeHandler}
        dataTest={`modal-${type}-drop-type`}
        required
      />
    </div>
  )
})
